/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OutputZoneShort } from './OutputZoneShort';
import {
    OutputZoneShortFromJSON,
    OutputZoneShortFromJSONTyped,
    OutputZoneShortToJSON,
} from './OutputZoneShort';

/**
 * 
 * @export
 * @interface OutputZoneAdminBroadcastMessage
 */
export interface OutputZoneAdminBroadcastMessage {
    /**
     * 
     * @type {string}
     * @memberof OutputZoneAdminBroadcastMessage
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputZoneAdminBroadcastMessage
     */
    expiration?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputZoneAdminBroadcastMessage
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputZoneAdminBroadcastMessage
     */
    message?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputZoneAdminBroadcastMessage
     */
    title?: string;
    /**
     * 
     * @type {Array<OutputZoneShort>}
     * @memberof OutputZoneAdminBroadcastMessage
     */
    zones?: Array<OutputZoneShort>;
}

/**
 * Check if a given object implements the OutputZoneAdminBroadcastMessage interface.
 */
export function instanceOfOutputZoneAdminBroadcastMessage(value: object): boolean {
    return true;
}

export function OutputZoneAdminBroadcastMessageFromJSON(json: any): OutputZoneAdminBroadcastMessage {
    return OutputZoneAdminBroadcastMessageFromJSONTyped(json, false);
}

export function OutputZoneAdminBroadcastMessageFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputZoneAdminBroadcastMessage {
    if (json == null) {
        return json;
    }
    return {
        
        'createdAt': json['createdAt'] == null ? undefined : json['createdAt'],
        'expiration': json['expiration'] == null ? undefined : json['expiration'],
        'id': json['id'] == null ? undefined : json['id'],
        'message': json['message'] == null ? undefined : json['message'],
        'title': json['title'] == null ? undefined : json['title'],
        'zones': json['zones'] == null ? undefined : ((json['zones'] as Array<any>).map(OutputZoneShortFromJSON)),
    };
}

export function OutputZoneAdminBroadcastMessageToJSON(value?: OutputZoneAdminBroadcastMessage | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'createdAt': value['createdAt'],
        'expiration': value['expiration'],
        'id': value['id'],
        'message': value['message'],
        'title': value['title'],
        'zones': value['zones'] == null ? undefined : ((value['zones'] as Array<any>).map(OutputZoneShortToJSON)),
    };
}

